import * as React from "react";

import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import { useOpenDaysApi } from "src/modules/shutdowns/api/open-day.api";
import OpenDayForm from "src/modules/shutdowns/components/OpenDayForm";

/**
 * Create edit open days form
 *
 */
const CreateEditOpenDayPage: React.ReactFCWithChildren<PageProps<unknown, {openDayId?: string;}>> = props => {
  const openDayId = props.match && props.match.params.openDayId ? parseInt(props.match.params.openDayId, 10) : null;
  const [ openDaysResponse, getOpenDay ] = useOpenDaysApi("GET_OPEN_DAY");

  React.useEffect(() => {
    if (openDayId) {
      getOpenDay(openDayId);
    }
  }, [ getOpenDay, openDayId ]);

  return (
    <Layout
      {...props}
      title="OpenDays"
    >
      <MainContentWrapper fill>
        {(openDaysResponse.data || !openDayId) &&
          <OpenDayForm initialOpenDay={openDaysResponse.data || null} />}
      </MainContentWrapper>
    </Layout>
  );
};

export default CreateEditOpenDayPage;
